import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const ChartDashboard = lazy(()=> import(/* webpackChunkName: "ChartDashboard" */'./components'));

const routes = () => <PrivateRoute exact path="/chart-dashboard" component={ChartDashboard} />;

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/chartDashboard/ChartDashboard/routes.js